import { Button } from "antd";
import React from "react";

const MessageA15 = (props) => {
  const { inputValue } = props;
  return (
    <div style={{ marginTop: "10px" }} className="action-tab">
      {props?.item?.text === "Submit" ? (
        <Button
          className="submit-btn"
          ref={inputValue}
          disabled={props.disabled}
        >
          <span
            style={{
              color: props.disable && "grey",
            }}
            id="main-tab1"
            onClick={() => {
              const data = JSON.parse(localStorage.getItem("inputValue"));
              console.log(data.key1, data.key1.length);
              if (!props?.disable) {
                props.handleClick(props?.item?.code, data?.key1, null);
                props.setTextOnClick(
                  // data?.key1?.length > 1 ? data?.key1?.join(", ") : data?.key1
                  data?.key1
                );
              }
            }}
          >
            Submit
          </span>
        </Button>
      ) : (
        <span
          className={
            !props.disable
              ? "chat-label action-tab "
              : "chat-labelnohover action-tab"
          }
          style={{ color: props.disable && "grey" }}
          id="main-tab1"
          onClick={() => {
            const data = JSON.parse(localStorage.getItem("inputValue"));
            if (!props.disable) {
              props.handleClick(props.item.code, data, null);
              props.setTextOnClick(props.item.text);
            }
          }}
        >
          {props.item.text}
        </span>
      )}
    </div>
  );
};

export default MessageA15;
